document.addEventListener('DOMContentLoaded' , () =>{
    // product - js-btn-col
    if(document.querySelector('.js-btn-col')){
        let btnCol = document.querySelectorAll('.js-btn-col'),
            prdList = document.querySelectorAll('.prd-list');
        
        btnCol.forEach(function(el){
            let colToggleBtnArray = Array.from(el.parentNode.querySelectorAll('.js-btn-col'));

            el.addEventListener('click' , function(e){
                if(!el.classList.contains('on')){
                    colToggleBtnArray.forEach(function(el){
                        el.classList.remove('on');
                    });
                    el.classList.add('on');
                }

                //목록 스타일
                if(el.classList.contains('btn-col1')){
                    prdList.forEach(function(el){
                        el.className = 'prd-list prd-list--col1';
                    })
                }else{
                    prdList.forEach(function(el){
                        el.className = 'prd-list';
                    })
                }
            });
        })
    }

    // product - product-lists-page
    if(document.querySelector('.product-lists-page')){
        const tabSwiper = new Swiper(".tab-swiper", {
            slidesPerView: 'auto'
        });
    }

    // product - product-view-page
    if(document.querySelector('.product-view-page')){
        const prdVisual = new Swiper(".prd-visual", {
            pagination: {
                el: ".prd-visual__control",
                type: "fraction",
            },
        });

        const detailedInfo = document.querySelector('.detailed-info__content');

        document.querySelector('.js_viewInfo').addEventListener('click', function(){
            detailedInfo.classList.add('active');
        });
        
        let reviewImgList = document.querySelectorAll(".review-list__img");
        reviewImgList.forEach((element, index) => {
            // console.log(index);
            element.classList.add("list-"+index)
            // console.log('.list-'+index)

            let reviewImg = new Swiper('.list-'+index, {
                slidesPerView: 'auto',
                slidesPerGroup: 1,
                spaceBetween: 10,
                observer : true,
                observeParents : true,
            });
        });
        
        //상품상세 js_tabBtn fixed
		const prdTabBtn = document.getElementById("js_tabBtn"),
              prdTabBtnOfs = window.scrollY + prdTabBtn.getBoundingClientRect().top;

		window.onscroll = function () {
		  let windowTop = window.scrollY;
		  if (windowTop >= prdTabBtnOfs) {
			prdTabBtn.classList.add("fixed");
		  } else {
			prdTabBtn.classList.remove("fixed");
		  }
		};
    }

    // product - buy-process
    if(document.querySelector('.product-view-page')){
        const productPage = document.querySelector('.product');
        const buyProcess = productPage.querySelector('.buy-process');

        setTimeout(function(){
            if(document.querySelector('.js_showOption')){
                productPage.querySelectorAll('.js_showOption').forEach(function(el){
                    el.addEventListener('click', function(){
                        buyProcess.classList.add('active');
                        document.querySelector('html, body').style.overflow = 'hidden';
                        document.querySelector('.buy-process__bg').style.display = 'block';
                        window.toggleFn.initFn();
                    });
                })

                productPage.querySelectorAll('.js_closeOption').forEach(function(el){
                    el.addEventListener('click', function(){
                        buyProcess.classList.remove('active');
                        document.querySelector('html, body').style.overflow = 'visible';
                        document.querySelector('.buy-process__bg').style.display = 'none';
                        document.querySelector('.js_toggle_btn').classList.remove('active');
                        document.querySelector('.buy-process__option-box').classList.remove('ovf-visible');
                    });
                })
            }
        }, 50);
    }
});